import { useState } from "react";
import { Footer } from "../components/layout/Footer";
import { NavBar } from "../components/layout/NavBar";
import { ScrollToTop } from "../components/layout/ScrollToTop";
import { SECTIONS } from "../constants/site";
import { BookingModal } from "../features/booking/BookingModal";
import { ContactSection } from "../features/contact/ContactSection";
import { GallerySection } from "../features/gallery/GallerySection";
import { HeroSection } from "../features/hero/HeroSection";
import { MarqueeBanner } from "../features/hero/MarqueeBanner";
import { ReviewsSection } from "../features/reviews/ReviewsSection";
import { ServicesSection } from "../features/services/ServicesSection";
import { StylistsSection } from "../features/stylists/StylistsSection";
import { useActiveSection } from "../hooks/useActiveSection";
import { useScrollReveal } from "../hooks/useScrollReveal";

export function SitePage() {
  const [bookingOpen, setBookingOpen] = useState(false);
  const [preselectedService, setPreselectedService] = useState(null);
  const activeSection = useActiveSection(SECTIONS);

  useScrollReveal();

  function handleNavigate(id) {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  }

  // Every Book button opens the same call-or-email panel. Nav and hero buttons
  // open it without a service; service cards pass the chosen service so the
  // pre-filled booking email names it.
  function handleBookNow() {
    setPreselectedService(null);
    setBookingOpen(true);
  }

  function handleBookService(service) {
    setPreselectedService(service);
    setBookingOpen(true);
  }

  function handleModalClose() {
    setBookingOpen(false);
  }

  return (
    <>
      <div className="grain-overlay" />
      <NavBar activeSection={activeSection} onNavigate={handleNavigate} onBookNow={handleBookNow} />
      <main>
        <HeroSection onBookNow={handleBookNow} />
        <MarqueeBanner />
        <ServicesSection onBookService={handleBookService} />
        <StylistsSection />
        <GallerySection />
        <ReviewsSection />
        <ContactSection />
      </main>
      <Footer />
      <ScrollToTop />
      <BookingModal
        isOpen={bookingOpen}
        onClose={handleModalClose}
        preselectedService={preselectedService}
      />
    </>
  );
}
